export const STATUS_LABELS = {
  DRAFT: "Brouillon",
  SUBMITTED: "Soumis",
  PRECHECK: "Pré-contrôle",
  UNDER_REVIEW: "En instruction",
  MORE_INFORMATION_REQUIRED: "Complément requis",
  APPROVED: "Approuvé",
  REJECTED: "Refusé",
  MANUFACTURER_SELECTION: "Choix fabricant",
  QUOTE_PENDING: "Devis en attente",
  ORDERED: "Commandé",
  IN_PRODUCTION: "En fabrication",
  INSTALLATION_SCHEDULED: "Pose planifiée",
  INSTALLED: "Installé",
  FIELD_INSPECTION: "Contrôle terrain",
  COMPLIANT: "Conforme",
  NON_COMPLIANT: "Non conforme",
  CLOSED: "Clôturé",
};

export const STATUS_COLORS = {
  DRAFT: "bg-zinc-100 text-zinc-700 border-zinc-300",
  SUBMITTED: "bg-blue-50 text-[#000091] border-blue-200",
  UNDER_REVIEW: "bg-amber-50 text-amber-800 border-amber-300",
  MORE_INFORMATION_REQUIRED: "bg-amber-50 text-amber-800 border-amber-300",
  APPROVED: "bg-emerald-50 text-emerald-800 border-emerald-300",
  MANUFACTURER_SELECTION: "bg-violet-50 text-violet-800 border-violet-300",
  QUOTE_PENDING: "bg-violet-50 text-violet-800 border-violet-300",
  REJECTED: "bg-red-50 text-[#E1000F] border-red-200",
  ORDERED: "bg-indigo-50 text-indigo-800 border-indigo-300",
  IN_PRODUCTION: "bg-indigo-50 text-indigo-800 border-indigo-300",
  INSTALLATION_SCHEDULED: "bg-cyan-50 text-cyan-800 border-cyan-300",
  INSTALLED: "bg-teal-50 text-teal-800 border-teal-300",
  FIELD_INSPECTION: "bg-amber-50 text-amber-800 border-amber-300",
  COMPLIANT: "bg-emerald-50 text-emerald-800 border-emerald-300",
  NON_COMPLIANT: "bg-red-50 text-[#E1000F] border-red-200",
  CLOSED: "bg-zinc-100 text-zinc-700 border-zinc-300",
};

export const ROLE_LABELS = {
  SUPER_ADMIN: "Super Administrateur",
  ADMIN_MAIRIE: "Administrateur Mairie",
  AGENT_MAIRIE: "Agent Mairie",
  AGENT_CONTROLE: "Agent de Contrôle",
  COMMERCANT: "Commerçant",
  FABRICANT: "Fabricant",
};

export const SIGN_TYPES = [
  "Enseigne en façade",
  "Enseigne perpendiculaire",
  "Enseigne lumineuse",
  "Panneau",
  "Lettres découpées",
  "Caisson",
  "Vitrophanie",
  "Autre",
];

export const MATERIALS = ["Aluminium", "PVC", "Dibond", "Plexiglas", "Bois", "Acier", "Verre"];
export const COLORS = ["Bleu", "Blanc", "Rouge", "Noir", "Vert", "Jaune", "Gris", "Or"];

export const KANBAN_COLUMNS = [
  "SUBMITTED",
  "UNDER_REVIEW",
  "MORE_INFORMATION_REQUIRED",
  "MANUFACTURER_SELECTION",
  "INSTALLED",
  "COMPLIANT",
  "REJECTED",
];
